export const fmtProduct = (product, reviewsQueries) => {
  const rating = reviewsQueries?.data?.reviewStats?.rating;
  const formattedRating = {
    ...product?.rating,
    average: rating?.calculated,
    reviews: rating?.count || null,
  };

  return { ...product, rating: formattedRating };
};

export const fmtBreadcrumbFromProduct = product =>
  product ? product?.breadcrumbs?.map(breadcrumb => ({ url: `/categoria/${breadcrumb.id}`, ...breadcrumb })) : null;

export const getBreadcrumb = (product, page) => page?.breadcrumb || fmtBreadcrumbFromProduct(product) || [];
